export const transform = (item, referral = {}) => {
  return {
    ...item,
    recipientResponse: getRecipientResponse({
      receivedStatus: item.receivedStatus,
      referral,
    }),
    recipientResponseOrder: getReferralResponseOrder(item, referral),
  }
}

export const transformMany = (items, referral = {}) => {
  return items.map((item) => transform(item, referral))
}

function getReferralResponseOrder(recipient, referral) {
  const referralOrder = {
    Selected: 0,
    Accepted: 1,
    Pending: 2,
    'No Response': 3,
    Declined: 4,
    Expired: 5,
  }
  return referralOrder[
    getRecipientResponse({
      receivedStatus: recipient.receivedStatus,
      referral,
    })
  ]
}

function getRecipientResponse({ receivedStatus, referral }) {
  if (!receivedStatus) {
    return
  }

  if (receivedStatus === 'Completed') {
    return 'Selected'
  }

  if (receivedStatus === 'Lost') {
    return 'No Response'
  }

  if (receivedStatus === 'Pending Sender' || receivedStatus === 'Not Selected') {
    return 'Accepted'
  }

  if (receivedStatus === 'Declined') {
    return 'Declined'
  }

  if (referral.status === 'Expired') {
    return 'Expired'
  }

  return 'Pending'
}
